module.exports = __webpack_public_path__ + "img/dwellys-logo.f0aeab07.svg";